import type { EmbeddedErrorResponse } from "./types";

/**
 * Custom error class for embedded auth errors.
 * These occur when the backend returns HTTP 200 but the response body
 * contains an authentication error (401/403).
 */
export class EmbeddedAuthError extends Error {
  public response: {
    status: number;
    data: EmbeddedErrorResponse;
    statusText: string;
  };

  constructor(embeddedError: EmbeddedErrorResponse, originalUrl: string) {
    const status = embeddedError.status || 401;
    const message = `Embedded auth error (${status}) at ${originalUrl}: ${embeddedError.message || embeddedError.error || "Authentication failed"}`;

    super(message);
    this.name = "EmbeddedAuthError";

    this.response = {
      status,
      data: embeddedError,
      statusText: embeddedError.error || "Unauthorized",
    };
  }
}

/**
 * Check if an error is an EmbeddedAuthError
 */
export function isEmbeddedAuthError(
  error: unknown,
): error is EmbeddedAuthError {
  return error instanceof EmbeddedAuthError;
}
